import { __rest, __awaiter } from '../../_virtual/_tslib.js';
import React__default, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import { FONT_WEIGHTS } from '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import { getRemValue } from '../../methods/getRemValue.js';
import 'bowser';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../constants/StateList.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../../constants/serviceTypeId.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';
import Search from '../search/Search.js';
import { ReactComponent as SvgBackBtn } from '../../icons/BackBtn.svg.js';
import Styles from './SearchFullScreenMobile.module.scss.js';
import './SearchFullScreenMobile.scss.js';

const SearchFullScreenMobile = (_a) => {
    var { isVisible = false, onClickBackBtn, id, isLoading, onSearch, onSelectItem, onInputChange, onFocus, selectedItem, options, searchText, labelKey, labelText, placeholder } = _a, props = __rest(_a, ["isVisible", "onClickBackBtn", "id", "isLoading", "onSearch", "onSelectItem", "onInputChange", "onFocus", "selectedItem", "options", "searchText", "labelKey", "labelText", "placeholder"]);
    const searchRef = useRef(null);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            if (isVisible) {
                (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                document.body.style.overflow = "hidden";
                if (window.scrollY !== 0) {
                    window.scrollTo({ left: 0, top: 0, behavior: "auto" });
                }
                (_b = document.querySelector(".sticky-inner-wrapper")) === null || _b === void 0 ? void 0 : _b.classList.add("inactive");
            }
            else {
                document.body.style.overflow = "unset";
                (_c = document.querySelector(".sticky-inner-wrapper")) === null || _c === void 0 ? void 0 : _c.classList.remove("inactive");
            }
        }))();
    }, [isVisible]);
    return isVisible ? (React__default.createElement("div", { className: classNames(Styles.container, "search_fullscreen_mobile") },
        React__default.createElement(Search, Object.assign({ ref: searchRef, id: id, isLoading: isLoading, onSearch: onSearch, onSelectItem: onSelectItem, onInputChange: onInputChange, selectedItem: undefined, options: options, searchText: searchText, labelText: labelText, labelKey: labelKey, onFocus: onFocus, 
            // setFocus={1}
            placeholder: placeholder, containerStyles: {
                height: "58px",
                border: "none",
                borderBottom: "none",
                borderRadius: 0
            }, inputWrapperStyles: {
                padding: "0"
                // marginTop: "12px"
            }, inputStyles: {
                paddingLeft: "16px",
                fontSize: getRemValue(15),
                letterSpacing: getRemValue(-0.15),
                color: "#3B52FF",
                fontWeight: FONT_WEIGHTS.medium,
                lineHeight: "18px"
            }, prefix: React__default.createElement("span", { onClick: onClickBackBtn },
                React__default.createElement(SvgBackBtn, null)), prefixClassName: Styles.prefix_container, setFocus: 1, minLength: 0 }, props)))) : null;
};

export { SearchFullScreenMobile as default };
//# sourceMappingURL=SearchFullScreenMobile.js.map
